// extracted by mini-css-extract-plugin
module.exports = {"input":"CheckBox_input__r2Nmt","selected":"CheckBox_selected__ZWdww","checkbox":"CheckBox_checkbox__4rF7O"};